import React from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import './MSSSRegistrationPage.css';

const steps = [
  'All presenters are required to register on the submission portal:',
  'To lodge an MS/SS, a request must be submitted via the submission portal.',
  'Within the submission, the email addresses of all presenters, including the Chair, must be entered. The system will automatically retrieve the corresponding details, which should be checked for accuracy.',
  'Submitted requests will be reviewed and approved upon receipt.',
  'Upon approval, papers or extended abstracts should be collected from all presenters, and the review process should be arranged. The Chair may conduct the review in an appropriate manner.',
  'Once all submissions are reviewed and finalised, a single zip file containing all papers or extended abstracts must be uploaded to the submission portal.',
  'A payment code will then be generated by the system for all presenters to complete registration payment.',
];

const publicationOptions = [
  'Paper without publication in proceedings',
  'Paper for proceedings publication',
  'Extended abstract only',
];

const MSSSRegistrationPage = () => {
  return (
    <section className="msss-page fade-in-up">
      <div className="msss-wrapper">
        <span className="badge msss-badge">Registration</span>
        <h1 className="msss-heading">Mini-Symposium (MS) / Special Session (SS) Submission Process</h1>
        <p className="msss-subtitle">
          Abstracts are not required for mini-symposia (MS) or special sessions (SS).
        </p>

        {/* Steps */}
        <div className="msss-steps">
          {steps.map((step, index) => (
            <div className="msss-step" key={index}>
              <div className="msss-step-number">{index + 1}</div>
              <div className="msss-step-text">
                {step}
                {index === 0 && (
                  <>
                    {' '}
                    <a href="https://ices2026-portal.com/" target="_blank" rel="noopener noreferrer" className="msss-portal-link">
                      Online Portal <FaExternalLinkAlt style={{ fontSize: '0.7rem', marginLeft: '4px' }} />
                    </a>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Post-payment section */}
        <div className="msss-post-payment">
          <p className="msss-post-payment-text">
            After payment is received, presenters (including the Chair) will be contacted to confirm their preferred publication option:
          </p>
          <ul className="msss-options-list">
            {publicationOptions.map((option, index) => (
              <li key={index}>{option}</li>
            ))}
          </ul>
        </div>

        {/* USB note */}
        <div className="msss-note">
          <p>All papers and extended abstracts will also be provided on a USB for access by conference delegates.</p>
        </div>

        {/* Completion */}
        <div className="msss-completion">
          <p>This completes the registration process.</p>
        </div>
      </div>
    </section>
  );
};

export default MSSSRegistrationPage;
